var cccApp = cccApp || {};

(function (app) {
    "use strict";

    app.msg = (function () {

        var hideSuccessTimeoutDict = {};

        var showInfo = function(msg, placeholder, showCloseButton, autoHide) {
            showMessage(msg, placeholder, "", showCloseButton, "", autoHide);
        }
      
        var showSuccess = function (msg, placeholder, showCloseButton, autoHide) {
            // Default to autohide
            if (typeof autoHide === "undefined") {
                autoHide = true;
            }

            showMessage(msg, placeholder, "notif-success", showCloseButton, "icon-close-green", autoHide);
        }

        var showWarning = function (msg, placeholder, showCloseButton, autoHide) {
            showMessage(msg, placeholder, "notif-warning", showCloseButton, "icon-close-yellow", autoHide);
        }

        var showError = function (msg, placeholder, showCloseButton, autoHide, autoHideDelay) {
            showMessage(msg, placeholder, "notif-error", showCloseButton, "icon-close-red", autoHide, autoHideDelay);
        }


        var showNetworkConnectionError = function() {
            showError("There is a problem with your connection, status will be checked when re-connected", "global-messages", true, false);
        };

        var showApplicationOfflineError = function(httpStatusCode) {

            if (typeof cccApp !== "undefined" && cccApp.connectivity) {
                cccApp.connectivity.appOffline(true);
                if (typeof httpStatusCode === "number") {
                    cccApp.connectivity.statusCode(httpStatusCode);
                }
            }

            var errorMessage = "You are offline";
            if (httpStatusCode === 503) {
                errorMessage = "Server is unavailable";
            }

            cccAppUnavailable(errorMessage);

            var computerMenuContainer = $("#computer-menu-container");
            if (computerMenuContainer && (typeof cccApp === "undefined" || !cccApp.computer)) {
                computerMenuContainer.addClass("hide");
            } else {
                computerMenuContainer.removeClass("hide");
            }
        };

        function showMessage(msg, placeholder, cssClass, showCloseButton, iconClass, autoHide, autoHideDelay) {
            placeholder = (typeof placeholder === "string" && placeholder) ? placeholder : "global-messages";
            cssClass = typeof cssClass !== "undefined" && cssClass !== null ? cssClass : "";
            showCloseButton = typeof showCloseButton !== "undefined" ? showCloseButton : placeholder === "global-messages";
            iconClass = typeof iconClass !== "undefined" && iconClass !== null ? iconClass : "";
            autoHide = typeof autoHide === "boolean" ? autoHide : false;
            autoHideDelay = autoHide ? (isNaN(autoHideDelay) ? 5000 : autoHideDelay) : 0;

            if (typeof msg === "undefined" || msg === null || msg === "") {
                return;
            }

            if (hideSuccessTimeoutDict[placeholder]) {
                clearTimeout(hideSuccessTimeoutDict[placeholder]);
            }

            $("#" + placeholder + " div").remove();

            var container = $("[id='" + placeholder + "']");

            var el = $(renderMessageHtml("notif " + cssClass, msg));

            if (placeholder === "global-messages") {
                container.append(el).removeClass("show").addClass("show");
            } else {
                container.append(el).hide().fadeIn();
            }

            

            if (showCloseButton) {
                showMessageCloseClick(el, placeholder, iconClass);
            }

            if (autoHide) {
                setAutoHide(placeholder, autoHideDelay);
            }
        }

        function renderMessageHtml(cssClass, msg) {

            var body = "<div class=\"" + cssClass + "\"><div class=\"message break-word\">" + msg + "</div></div>";

            return body;
        }

        function showMessageCloseClick(element, placeholder, iconClass) {
            var closeDiv = element.prepend('<div class="icon-close-container"><a href="#" class="icon-close ' + iconClass + '"></a></div>').addClass("closeable");
            closeDiv.find("a.icon-close").click(function () {
                element.fadeOut(400, function () {
                    $("#" + placeholder).removeClass("show");
                    $("#" + placeholder).css("display", "");
                    element.remove();
                });
                return false;
            });
        }

        function setAutoHide(placeholder, delay) {
            delay = delay || 5000;
            placeholder = (typeof placeholder === "string" && placeholder) ? placeholder : "global-messages";

            if (hideSuccessTimeoutDict[placeholder]) {
                clearTimeout(hideSuccessTimeoutDict[placeholder]);
            }

            var timeout = setTimeout(function() {
                    if (hideSuccessTimeoutDict[placeholder] === timeout) {
                        $("#" + placeholder + " div")
                            .fadeOut(400,
                                function() {
                                    $("#" + placeholder + " div").remove();
                                    $("#" + placeholder).removeClass("show");
                                    $("#" + placeholder).css("display", "");
                                });
                    }
                },
                delay);

            hideSuccessTimeoutDict[placeholder] = timeout;
        }

        // clear error messages in given placeholder, callback is optional
        var clearErrorMessages = function (placeholder, callback) {
            $("#" + placeholder).removeClass("show");
            $("#" + placeholder).css("display", "");

            $("#" + placeholder + " div").remove();

            if (callback != null) {
                try {
                    callback();
                } catch (e) {
                    //Do nothing
                }
            }
        }

        var clearTaggedMessages = function (placeholder, tag, callback) {
            $("#" + placeholder + "[data-tag='" + tag + "'] div").remove();

            if (callback !== null) {
                try {
                    callback();
                } catch (e) {
                    //Do nothing
                }
            }
        }

        var clearAllErrorMessages = function (placeholder) {
            //reset any previous error messages
            clearErrorMessages("global-messages");
            clearErrorMessages(placeholder);
        }

        return {
            info: showInfo,
            success: showSuccess,
            warning: showWarning,
            error: showError,
            appOffline: showApplicationOfflineError,
            networkFailure: showNetworkConnectionError,
            clear: clearErrorMessages,
            clearAll: clearAllErrorMessages,
            clearTagged: clearTaggedMessages
        }
    }());

}(cccApp));